import React from 'react'
import styled from 'styled-components'
import { media } from '../styles/vars'

const Container = styled.div`
direction:rtl;
text-align:center;
`
const PedalImage = styled.img`
transition:transform .4s, filter .4s;
transform-origin:center top;
max-width:100px;
margin:0 auto;
${
    media.small`
    max-width:80px;
    `
    }
${
    media.desktop`
    max-width:270px;
    `
    }
`
const DynamicPedalImage = styled(PedalImage) `
transform:${props => props.active ? 'scale(1)' : 'scale(.8)'};
filter:${props => props.active ? 'unset' : 'grayscale(100%)'};
cursor:${props => props.active ? 'default' : 'pointer'};
`

const PedalItem = (props) => {
    const _onClick = () => props.onClick(props.idx);
    return (
        <Container onClick={_onClick}>
            <div>
                <DynamicPedalImage
                    active={props.active}
                    src={`./static/pedal_images/${props.imgName}`} />
            </div>
        </Container>
    )
}

export default PedalItem;


// WEBPACK FOOTER //
// ./src/components/PedalItem.jsx